type CardSpendStatusTooltipEntry = {
  color?: string;
  dataKey?: string | number;
  name?: string | number;
  value?: number | string | ReadonlyArray<number | string>;
  payload?: { fullDate?: string };
};

type CardSpendStatusTooltipProps = {
  active?: boolean;
  payload?: ReadonlyArray<CardSpendStatusTooltipEntry>;
  label?: string | number;
  incomplete: boolean;
};

const TOOLTIP_BACKGROUND = "#111827";
const TOOLTIP_FALLBACK_COLOR = "#64748B";

export const CardSpendStatusTooltip = ({
  active,
  payload,
  label,
  incomplete,
}: CardSpendStatusTooltipProps) => {
  if (!active || !payload?.length) return null;

  const fullDate = payload[0]?.payload?.fullDate;

  return (
    <div
      role="tooltip"
      style={{
        width: "max-content",
        minWidth: "132px",
        whiteSpace: "nowrap",
        padding: "8px 12px",
        borderRadius: "8px",
        backgroundColor: TOOLTIP_BACKGROUND,
        boxShadow:
          "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
      }}
    >
      <div
        style={{
          color: "#94A3B8",
          fontSize: "11px",
          fontWeight: 500,
          marginBottom: "6px",
        }}
      >
        Date: {String(fullDate || label || "")}
      </div>
      <div style={{ display: "grid", gap: "6px" }}>
        {payload.map((item) => {
          const name = String(item.name || item.dataKey || "");
          const lineColor =
            typeof item.color === "string" ? item.color : TOOLTIP_FALLBACK_COLOR;
          const count = Number(item.value || 0);

          return (
            <div
              key={String(item.dataKey || name)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "7px",
                color: "#F8FAFC",
                fontSize: "12px",
                fontWeight: 600,
              }}
            >
              <span
                aria-label={`${name} line color`}
                style={{
                  width: "7px",
                  height: "7px",
                  flex: "0 0 7px",
                  borderRadius: "50%",
                  backgroundColor: lineColor,
                }}
              />
              <span>
                {name}: {incomplete ? "Loaded " : ""}
                {count}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
